import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Xmldefs } from '../../core/entities/xmldefs.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class XmldefsService {
    readonly BASE: any = PETICIONES.xmldefs;

    constructor(private http: HttpClient) { }

    /**
   * @description
   * Obtiene todos los xmldefs
   */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene un xmldefs por su id
   */
  public findById(id: number): Observable<any> {
    let idxmldefs: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idxmldefs).pipe(delay(DELAY));
  }

  /**
   * @description
   * Guarda un xmldefs en la base de datos
   */
  public postXmldef(xmldefs: Xmldefs): Observable<any> {
    const json = JSON.stringify(xmldefs);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.postXmldefs, json, {headers: headers}).pipe(delay(DELAY));
  }

  /**
   * @description
   * Borra un xmldefs en la base de datos
   */
  public deleteXmldef(xmldefs: Xmldefs): Observable<any> {
    let idxmldefs: string = (xmldefs.id !== undefined && xmldefs.id !== null ? xmldefs.id + "" : "");
    return this.http.get(this.BASE.deleteXmldefs + "/" + idxmldefs).pipe(delay(DELAY));
  }

}